import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, Button, Label, Form } from 'reactstrap';
import FormWrapper from './../../../commonComponents/formWrapper/FormWrapper.container';
import './ResendActivationStaffMember.css';
import _ from 'lodash';
import { sharedLabelsPath } from "../../../../reducers/common/localization";

class ResendActivationStaffMember extends Component {
    render() {
        return (
                <Modal isOpen={this.props.isOpen} toggle={this.onResendActivationCancel}>
                    <ModalBody>
                        <FormWrapper
                            successMessage={_.get(this.props.translation, 'resend_activation.success_message')}
                        >
                            <Form className='resend-employee-activation-form' onSubmit={this.onResendActivationSubmit}>
                                <Label>
                                    {_.get(this.props.translation, 'resend_activation.employee_label').replace('{email}', this.props.email)}
                                </Label>
                                <div className="modal-buttons-container">
                                    <Button color="secondary"
                                        onClick={this.onResendActivationCancel}>{_.get(this.props.translation, sharedLabelsPath.cancel_button)}</Button>
                                    <Button className="olive-green-btn"
                                        type="submit">{_.get(this.props.translation, 'resend_activation.submit_button')}</Button>
                                </div>
                            </Form>
                        </FormWrapper>
                    </ModalBody>
                </Modal>
            );
    }

    onResendActivationSubmit = (e) => {
        e.preventDefault();

        this.props.onResendActivation(this.props.email)
    };

    onResendActivationCancel = () => {
        this.props.onCancel();
    };
}

ResendActivationStaffMember.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    email: PropTypes.string,
    translation: PropTypes.object.isRequired,
    onResendActivation: PropTypes.func,
    onCancel: PropTypes.func
};

export default ResendActivationStaffMember;



// WEBPACK FOOTER //
// ./src/components/staffMemberManagement/staffMemberModal/resendActivationStaffMember/ResendActivationStaffMember.js